import {FC, useCallback, useMemo} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'
import { RichText } from '../RichText/RichText'

interface Props {}

export const InputProductSpec: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, soItem} = useAppSelector(soSelector)

  const defaultValue = useMemo(() => orderItem?.product_spec ?? '', [orderItem])

  const handleChange = useCallback((product_spec: string) => {
    dispatch(setSoItem({...soItem, product_spec}))
  }, [])

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>{t('Product Spec')}</Form.Label>
      </Col>
      <Col md={8}>
          <RichText
            containerClassName='mt-4'
            content={defaultValue}
            onUpdate={({editor}) => handleChange(editor.getHTML())}
          >
            <div style={{display: 'none'}}>&nbsp;</div>
          </RichText>
        {/* <Form.Control
          size='sm'
          aria-label='Default example'
          defaultValue={defaultValue}
          onChange={({target}) => handleChange(target.value)}
        /> */}
      </Col>
    </Row>
  )
}
